import '../../vendor/jquery.vimeo.api'
import '../../vendor/player'
import RmSlider from '../../vendor/rm-slider';

export default {
    init() {
        this.initSlider()
        this.playPauseVideo()
    },

    playPauseVideo() {
        $('.embed-career').on("click", function () {
            const iframe = $(this).find('iframe')[0]
            let videoContentPlayer = new Vimeo.Player(iframe);

            $(this).toggleClass("played");

            if ($(this).hasClass("played")) {
                videoContentPlayer.play();
                videoContentPlayer.setVolume(1);

            } else {
                videoContentPlayer.pause();
            }
        })
    },

    initSlider() {
        const rmSlider = new RmSlider($('.module-career'), true)
        rmSlider.init()
    }

};